
                                module.exports = new Proxy({}, {
                                    get: function() {
                                        const shouldLog = window?.posthog?.config?.debug
                                        if (shouldLog) {
                                            console.warn('[TOOLBAR] Attempted to use denied module:', "scenes/data-warehouse/settings/dataWarehouseSettingsLogic");
                                        }
                                        return function() { 
                                            return {} 
                                        }
                                    }
                                });
                            